import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07b5eaae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "portfolio", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " =========== ", -1))
const _hoisted_3 = { class: "portfolioContents" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "tagBlock" }

import { useThemeStore } from '../stores/themeStore'
import { portfolioData } from '../constants/data'

interface portfolioData {
  id: number
  portTitle: string
  blurb: string
  image: string
  tags: string[]
  portURL: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Portfolio',
  setup(__props) {

const store = useThemeStore();
const items = portfolioData;
const itemsLength = portfolioData.length;
const tags = items.map(item => item.tags);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(store).dark ? 'portfolioContainer' : 'portfolioContainerLight')
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(_unref(store).dark ? 'portfolioItem' : 'portfolioItemLight')
        }, [
          _createElementVNode("a", {
            href: item.portURL,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              class: "portfolioImage",
              src: item.image,
              alt: item.portTitle
            }, null, 8, _hoisted_5),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(store).dark ? 'portfolioTitle' : 'portfolioTitleLight')
            }, _toDisplayString(item.portTitle), 3)
          ], 8, _hoisted_4),
          _createElementVNode("div", {
            class: _normalizeClass(_unref(store).dark ? 'portfolioText' : 'portfolioTextLight')
          }, [
            _createElementVNode("div", {
              innerHTML: item.blurb,
              class: "link"
            }, null, 8, _hoisted_6)
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, (tag) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tag[0],
                class: _normalizeClass(_unref(store).dark ? 'portfolioTags' : 'portfolioTagsLight')
              }, _toDisplayString(tag), 3))
            }), 128))
          ])
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})